import { styled } from '@linaria/react';

export const SidebarCard = styled.div`
    background: white;
    border-radius: 4px;
    padding: 1rem;
    border: 1px solid #e9ecef;
    margin-bottom: 0.5rem;
`;

export const SidebarTitle = styled.h3`
    color: #333;
    margin: 0 0 0.75rem 0;
    font-size: 1.1rem;
    font-weight: 700;
    text-align: center;
    border-bottom: 2px solid #dee2e6;
    padding-bottom: 0.4rem;
`;

export const SidebarContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;

export const SidebarItem = styled.div`
    padding: 0.25rem 0.5rem;
    background: #f8f9fa;
    border-radius: 4px;
    border-left: 2px solid #dee2e6;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.5rem;
    overflow: hidden;
    min-width: 0;

    label {
        font-weight: 600;
        color: #495057;
        font-size: 0.75rem;
        white-space: nowrap;
        flex-shrink: 0;
    }

    span {
        color: #333;
        font-size: 0.75rem;
        line-height: 1.3;
        text-align: right;
        word-break: break-word;
        min-width: 0;
    }

    select {
        min-width: 0;
    }
`;
